//const API = process.env.NODE_ENV !== 'prod' ? 'https://local.asobol.pl' : 'https://api.zdrowiezaczynasiewglowie.com';
// const API = process.env.NODE_ENV !== 'prod' ? 'http://localhost:8000' : 'http://localhost:8000';
// const API = process.env.NODE_ENV !== 'prod' ? 'https://zdrowei-api.herokuapp.com' : 'https://zdrowei-api.herokuapp.com';
const API = process.env.NODE_ENV !== 'prod' ? 'https://api2.zdrowiezaczynasiewglowie.com' : 'https://api2.zdrowiezaczynasiewglowie.com';


// console.log(process.NODE_ENV);

const defaultHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  // 'Access-Control-Allow-Origin': '*',
};

const IRI = {
  course: '/course/',
  courseByCode: '/course/code/',
  courseExam: '/course/exam/',
  examAnswers: '/exam-answers',
  downloadCertificate: '/certificates/download'
};

export default API;

export {
  defaultHeaders,
  IRI,
};
